<div class="header"[ngClass]="isPatientSection ? 'header_color_patients' : 'header_color_pros'">
<img [src]="isMd ? logo : logoMobile" alt="Logo Medpago" class="logo">
<span class="text_center">{{textCenter}}</span>
<span class="text_right" (click)="navigateFn()">{{textRight}}</span>
</div>
